import React, { Component } from 'react';
import { Auth } from 'aws-amplify';

class Sidebar extends Component {
    // side bar of dashboard. Each has a font awsome icon. When user sign out, it goes back to the login page
    render() {
        return (
            <div className='sidebar-container'>
                <div className='sidebar-logo'>
                    Home Energy Report
                    </div>
                <ul className='sidebar-navigation'>
                    <li className='header'>Navigation</li>
                    <li><a href='dashboard'>
                        <i className='fa fa-tachometer' aria-hidden='true'></i>
                        Dashboard
                        </a>
                    </li>
                    <li>
                        <a href='datacorrect'>
                            <i className='fa fa-cog' aria-hidden='true'></i>
                            Data Update
                        </a>
                    </li>
                    <li>
                        <a href='request'>
                            <i className='fa fa-clipboard' aria-hidden='true'></i>
                            Request
                        </a>
                    </li>
                    <li className='header'>User Menu</li>
                    <li>
                        <a href='changepwd'>
                            <i className='fa fa-lock' aria-hidden='true'></i>
                            Change Password
                        </a>
                    </li>
                    <li onClick={async () => await Auth.signOut()}>
                        <a href='/'>
                            <i className='fa fa-sign-out' aria-hidden='true' ></i>
                            Sign Out
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}
export default Sidebar;





// WEBPACK FOOTER //
// ./src/components/sidebar/index.js